import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CategoryIcon from "@mui/icons-material/Category";
import DescriptionIcon from "@mui/icons-material/Description";
import PaidIcon from "@mui/icons-material/Paid";
import FactoryIcon from "@mui/icons-material/Factory";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SearchIcon from "@mui/icons-material/Search";
import WarningIcon from "@mui/icons-material/Warning";
import styled from "styled-components";
import { useTheme } from "@mui/material/styles";
import { Image, Search, Shapes, FileText, CircleDollarSign, Building2 } from "lucide-react";

type Props = {
    step: number;
    completed: { [k: number]: boolean };
    setCompleted: (completed: { [k: number]: boolean }) => void;
    error: boolean;
};

export const SoecoStepper = (props: Props) => {
    const theme = useTheme();

    const steps = [
        "CameraForm",
        "PredictProduct",
        "ProductCategoryForm",
        "DetailsForm",
        "PriceForm",
        "QuantityLocationForm",
    ];

    const stepError = <WarningIcon color="error" fontSize="large" />;
    const stepComplete = <CheckCircleIcon color="success" fontSize="large" />;

    const stepsIconActive = [
        <Image size={32} color={theme.palette.secondary.main} />,
        <Search size={32} color={theme.palette.secondary.main} />,
        <Shapes size={32} color={theme.palette.secondary.main} />,
        <FileText size={32} color={theme.palette.secondary.main} />,
        <CircleDollarSign size={32} color={theme.palette.secondary.main} />,
        <Building2 size={32} color={theme.palette.secondary.main} />,
    ];

    const stepsIconInactive = [
        <Image size={32} color={theme.palette.primary.main} />,
        <Search size={32} color={theme.palette.primary.main} />,
        <Shapes size={32} color={theme.palette.primary.main} />,
        <FileText size={32} color={theme.palette.primary.main} />,
        <CircleDollarSign size={32} color={theme.palette.primary.main} />,
        <Building2 size={32} color={theme.palette.primary.main} />,
    ];

    return (
        <StepperWrapper>
            <Stepper activeStep={props.step} alternativeLabel>
                {steps.map((label, index) =>
                    props.error && index === props.step ? (
                        <Step key={label}>
                            <StepLabel error icon={stepError}></StepLabel>
                        </Step>
                    ) : (
                        <Step key={label} completed={props.completed[index]}>
                            <StepLabel
                                icon={
                                    props.completed[index]
                                        ? stepComplete
                                        : index === props.step
                                        ? stepsIconActive[index]
                                        : stepsIconInactive[index]
                                }
                            />
                        </Step>
                    ),
                )}
            </Stepper>
        </StepperWrapper>
    );
};

const StepperWrapper = styled.div`
    margin-top: 1rem;
`;
